@if (valueAsArray(); as values) {
  <div
    class="values f-body-m"
    [class.f-muted]="color() === 'gray'"
    [class.f-danger]="color() === 'red'"
    [class.wrap]="wrap()"
    [onyxTooltip]="wrap() ? '' : tooltip()"
    [onyxTooltipDelay]="TOOLTIP_DELAY"
    [onyxTooltipDisabled]="
      overflowHelper.hasNoOverflow.bind(overflowHelper, valueElement)
    "
    #valueElement
  >
    @for (value of values; track value) {
      <span>
        <ng-container
          *ngTemplateOutlet="
            translateTemplate;
            context: { value: value, comma: !$last }
          "
        ></ng-container>
      </span>
    }
  </div>
} @else if (valueAsString(); as stringValue) {
  <p
    class="f-body-m"
    [class.f-muted]="color() === 'gray'"
    [class.f-danger]="color() === 'red'"
    [class.wrap]="wrap()"
    [onyxTooltip]="tooltip()"
    [onyxTooltipDelay]="TOOLTIP_DELAY"
    [onyxTooltipDisabled]="
      overflowHelper.hasNoOverflow.bind(overflowHelper, valueElement)
    "
    #valueElement
  >
    <ng-container
      *ngTemplateOutlet="translateTemplate; context: { value: stringValue }"
    ></ng-container>
  </p>
} @else {
  -
}

<ng-template let-value="value" let-comma="comma" #translateTemplate>
  {{ (dictionaryCode() ? `${dictionaryCode()}.${value}` : value) | translate
  }}{{ comma ? ',' : '' }}
</ng-template>
